module.exports = __webpack_public_path__ + "img/56.e248ccd7.png";